import {
  useQuery,
} from '@tanstack/react-query'

import { singularResourcefulJointScenarioRequest } from '../requests'

export function useForecastQuery({
  jointScenarioId,
  initialData,
  queryKey
}) {
  const forecastRequest = singularResourcefulJointScenarioRequest(
    jointScenarioId, 'forecast'
  )

  const forecastQuery = useQuery({
    queryFn: forecastRequest.show,
    queryKey,
    initialData
  })

  const isFetching = forecastQuery.isFetching

  const isAnyLoading = forecastQuery.isFetching

  return {
    data: forecastQuery.data,
    status: forecastQuery.status,
    refetch: forecastQuery.refetch,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading,
  }
}
